var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body" },
    [
      _c("h2", [_vm._v("Let's Get Started!")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Tell us a bit about your event:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.eventName,
            expression: "eventName"
          }
        ],
        attrs: { type: "text", placeholder: "Event Name" },
        domProps: { value: _vm.eventName },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.eventName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("v-date-picker", {
        attrs: { mode: "range", "is-double-paned": "", attributes: _vm.attrs },
        model: {
          value: _vm.eventRange,
          callback: function($$v) {
            _vm.eventRange = $$v
          },
          expression: "eventRange"
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "button", value: "next" },
        on: {
          click: function($event) {
            _vm.save()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74bc6182", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74bc6182","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/eventCreationPrompt.vue
// module id = vAWj
// module chunks = 1